import React, { useMemo, useState, useContext, useEffect } from 'react';

import { SocketContext } from 'context/SocketContext';

window._harvestPlatformConfig = {
    'applicationName': 'Nifty',
    'permalink': 'https://nifty.pm/tasks/%ITEM_ID%'
};

export const HarvestContext = React.createContext();

export const HarvestProvider = ({ children }) => {
    const [runningTimer, setRunningTimer] = useState(null);

    const handleTimerUpdate = value => {
        if (!value?.external_reference) {
            setRunningTimer(null);
            return;
        }

        setRunningTimer({
            task: value.external_reference.external_id || value.external_reference.id,
            project: value.external_reference.external_group_id || value.external_reference.group_id
        });
    }

    const handleMessage = message => {
        if (message.origin === 'https://platform.harvestapp.com') {
            if (message.data?.type === 'timer:update' || message.data?.type === 'timer:started' || message.data?.type === 'timer:stopped') {
                handleTimerUpdate(message.data.value);
            }
        }
    }

    useEffect(() => {
        const script = document.createElement('script');

        script.src = 'https://platform.harvestapp.com/assets/platform.js';
        script.async = true;

        document.body.appendChild(script);

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
            document.body.removeChild(script);
        }
    }, []);

    const value = useMemo(() => ({
        runningTimer
    }), [runningTimer]);

    return (
        <HarvestContext.Provider value={value}>
            { children }
        </HarvestContext.Provider>
    )
};
